import BondDataManagement from '.'
import { PageRoute } from '../../routes/routerInterface'
import { checkProdSite } from '../../helpers/checkProdSite'

const bondDataRoutes: PageRoute[] = [
  {
    path: '/bond-data-management',
    element: BondDataManagement as any,
    isProtected: true,
    permission: checkProdSite(true, 'Admin'),
  },
]

export default bondDataRoutes
